import axios from 'axios'

export default new class TestTypeService {
  get (testTypeId) {
    return axios.get('/test-types/' + testTypeId)
  }

  getList () {
    return axios.get('/test-types',)
  }

  new (data) {
    return axios.post('/test-types', data)
  }

  update (testTypeId, data) {
    return axios.put('/test-types/' + testTypeId, data)
  }

  delete (testTypeId) {
    return axios.delete('/test-types/' + testTypeId)
  }
}()
